module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAMAAAAolt3jAAAAVFBMVEUAAACwAACwAACwAACwAACwAACwAACwAACwAACwAACwAACvAACvAACtAAC/AACwAACwAACwAACwAACvAACwAACvAACxAACwAACwAACxAAC0AACwAAA6LHAgAAAAG3RSTlMA+Bfv7NR49OXhLikmHwjZy8SriXtpaGc9NBEjBvglAAAAW0lEQVQI123JRxKAIBBE0UZByeY497+nCEix8G+6XjVi9yQcSo0gUvaTGygkTZJVFOP6lZGUay9Acyr1JzgrCj88r9gA7Q+FqLkAXcUOODL7xD1zZoytwBZm9A+CRgvLKGMOBgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newlist-mulu.png
// module id = k141
// module chunks = 1